'use client';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { defaultLocale } from '@/i18n/routing';

const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
	const router = useRouter();

	useEffect(() => {
		// Use browser language or default locale
		const browserLang = navigator.language.toLowerCase();
		const supportedLocales = ['ko', 'en', 'de', 'fr', 'ja', 'vi', 'th', 'es', 'id', 'ms', 'zh-cn', 'zh-tw', 'mn'];
		const locale = supportedLocales.includes(browserLang)
			? browserLang
			: supportedLocales.includes(browserLang.split('-')[0])
				? browserLang.split('-')[0]
				: defaultLocale;
		router.push(`/${locale}`);
	}, []);
	return (
		// global-error must include html and body tags
		<html>
			<body>
				<h2>Something went wrong!</h2>
				<button onClick={() => reset()}>Try again</button>
			</body>
		</html>
	);
};

export default GlobalError;
